/* eslint-disable no-undef */
/* eslint-disable no-underscore-dangle */
/**
 * Request US consentData.
 * Spec IAB: https://github.com/InteractiveAdvertisingBureau/USPrivacy/blob/master/CCPA/USP%20API.md#requirements-for-us-privacy-user-signal-api
 *
 */
function getConsentData() {
  return new Promise((resolve) => {
    if (typeof window.__uspapi === 'function') {
      window.__uspapi('getUSPData', 1, (uspData, success) => {
        if (success) {
          resolve(uspData.uspString || '');
        } else {
          resolve('');
        }
      });
      setTimeout(() => resolve(''), 750);
    } else {
      resolve('');
    }
  });
}

export default {
  getConsentData,
};
